import { Component, inject } from "@angular/core";
import { PurchaseOrderInvoiceViewModel } from "@tylertech/tyler-api-types";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

/**
 * @deprecated I think this has been replaced by a MetadataAction in the backend.
 * TODO - Confirm and Remove.
 */
export interface InvoiceDialogData
{
    readonly invoices: PurchaseOrderInvoiceViewModel[];
}

/**
 * @deprecated I think this has been replaced by a MetadataAction in the backend.
 * TODO - Confirm and Remove.
 */
@Component({
    selector: "invoice-dialog-component",
    templateUrl: "./poInvoiceDialog.tmpl.html",
    standalone: false
})
export class InvoiceDialogComponent
{
    private readonly dialogRef = inject<MatDialogRef<InvoiceDialogComponent>>(MatDialogRef);
    private readonly data = inject<InvoiceDialogData>(MAT_DIALOG_DATA);


    get invoices(): PurchaseOrderInvoiceViewModel[]
    {
        return this.data.invoices;
    }

    close(): void
    {
        this.dialogRef.close();
    }
}
